import React, { Component } from "react";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import am4lang_pl_PL from "@amcharts/amcharts4/lang/pl_PL";
import { getTimeZone } from "@amcharts/amcharts4/.internal/core/utils/Utils";

am4core.useTheme(am4themes_animated);

class Chart extends Component {
  state = {
    chart: {},
    activeTimeButton: this.props.activeTimeButton,
    activeChart: this.props.activeChart,
    activeDevice: this.props.activeDevice
  };

  renderChart() {
    let chart = am4core.create("chartdiv", am4charts.XYChart);
    chart.language.locale = am4lang_pl_PL;
    //chart.paddingRight = 20;
    let link =
      "https://hgsystem.pl/getjsondata.php?ile=" +
      this.props.activeTimeButton +
      "&id=" +
      this.props.activeChart +
      "&device=" +
      this.props.activeDevice;

    fetch(link)
      .then(response => response.json())
      .then(response => {
        // var sin = eval(xmlhttp.responseText);
        var data = [];
        //console.log(sin);
        response.forEach(element => {
          data.push({
            date: new Date(element[0] - 3600000),
            value: element[1]
          });
        });
        //console.log(data);
        //console.log(data.length);
        chart.data = data;

        let dateAxis = chart.xAxes.push(new am4charts.DateAxis());
        dateAxis.renderer.grid.template.location = 0;
        dateAxis.tooltipDateFormat = "dd MMM yyyy, HH:mm";

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.tooltip.disabled = true;

        valueAxis.renderer.minWidth = 1;
        let axisText;
        this.props.activeChart === 1
          ? (axisText = "Litry")
          : (axisText = "Temperatura");

        let series = chart.series.push(new am4charts.LineSeries());
        series.dataFields.dateX = "date";
        series.tooltipText = "{valueY}[/]";

        series.dataFields.valueY = "value";
        series.strokeWidth = 2;
        series.fillOpacity = 0.3;

        let fillModifier = new am4core.LinearGradientModifier();
        fillModifier.opacities = [1, 0];
        fillModifier.offsets = [0, 1];
        fillModifier.gradient.rotation = 90;
        series.segments.template.fillModifier = fillModifier;

        //series.tooltipText = "{valueY.value} {dateX.date}";
        chart.cursor = new am4charts.XYCursor();
        chart.cursor.behavior = "panX";
        let scrollbarX = new am4charts.XYChartScrollbar();
        scrollbarX.series.push(series);
        chart.scrollbarX = scrollbarX;

        this.chart = chart;
        //this.chart.yAxes.values[0].title.text = axisText;
      });
  }

  componentDidMount() {
    // this.renderChart();
  }

  componentDidUpdate() {
    if (this.chart) {
      this.chart.dispose();
    }
    if (this.props.renderChart) this.renderChart();
  }

  componentWillUnmount() {
    if (this.chart) {
      //console.log("chart dispose");
      this.chart.dispose();
    }
  }

  render() {
    return (
      <div>
        <div id="chartdiv" style={{ width: "100%", height: "400px" }}>
          {" "}
        </div>
      </div>
    );
  }
}

export default Chart;



// WEBPACK FOOTER //
// ./src/components/Charts/chart.jsx